function formatDigits(num: number, lang: string) {
  if (num == null) return '';
  const formatted = new Intl.NumberFormat(`${lang}-CA`, {
    style: 'decimal',
    maximumFractionDigits: 2
  }).format(num);
  return formatted;
}

export default formatDigits;
